module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4n8r7n-3a335e92e4979c1fcc4c198e8f8593fa.svg";